import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { setGitPathHttpHeader } from '@y42/feature/git';
import { ORG_API_URL_PARAM } from '@y42/model';
import { Observable, tap } from 'rxjs';
import { CardinalityModel } from './cardinality.model';
import { TableCardinalityStore } from './table-cardinality.store';

interface TableCardinalityServiceParams {
  previewLimit?: number;
}

@Injectable()
export class TableCardinalityService {
  constructor(private readonly http: HttpClient, private readonly tableCardinalityStore: TableCardinalityStore) {}

  getAll(tablePath: string, params: TableCardinalityServiceParams = {}): Observable<CardinalityModel> {
    this.tableCardinalityStore.setLoading(true);
    const httpParams = new HttpParams({ fromObject: { ...params } });

    return this.http
      .post<CardinalityModel>(
        this.getAllFinalUrl(),
        {},
        { params: httpParams, headers: setGitPathHttpHeader(tablePath) },
      )
      .pipe(
        tap((cardinality) => {
          if (cardinality) {
            this.setCardinality(cardinality);
          }
          this.tableCardinalityStore.setLoading(false);
        }),
      );
  }

  getById(tablePath: string, fieldName: string, params: TableCardinalityServiceParams = {}) {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this.http.post<CardinalityModel>(
      this.getByIdFinalUrl(),
      { column: fieldName },
      { params: httpParams, headers: setGitPathHttpHeader(tablePath) },
    );
  }

  setCardinality(cardinality?: CardinalityModel) {
    this.tableCardinalityStore.update((state) => ({
      ...state,
      tableCardinality: cardinality,
    }));
  }

  private getAllFinalUrl() {
    return `${environment.url.analytic_api}/company/${ORG_API_URL_PARAM}/cardinality`;
  }

  private getByIdFinalUrl() {
    return `${this.getAllFinalUrl()}/column`;
  }
}
